import { useCallback, useEffect, useState } from "react";
import { updateEnvironment } from "../../../actions/environment.action";
import { useDispatch, useSelector } from "react-redux";
import { requestLivechat } from "../../../utilities/LiveChat";
import { submitAnswer } from "../../../utilities/Answer";
import { STORE } from "../../../store";
import { IQuestion } from "../../../interfaces/Question";

import markdownIt from 'markdown-it';
import mila from "markdown-it-link-attributes";

let md = markdownIt({ html: false, linkify: true, typographer: true, breaks: false });
md.use(mila, { attrs: { target: "_blank", rel: "noopener", } });

export default function SingleSelect(props: any) {
	const { message, currentIndex, count, topMargin }: any = props;
	const design = useSelector((state: any) => state?.design);
	const environment = useSelector((state: any) => state?.environment);
	const dispatch = useDispatch();
	const [options, setOptions] = useState([]);

	useEffect(() => {
		setOptions(() => message.options);
	}, [setOptions, message.options]);

	/**
	 * Author: Mayank Mohan
	 * Title: handle live chat using options
	 * Descripiton: Added for requesting live chat in case of unusual ai-response
	 **/

	const selectOption = useCallback((value: string, next: any, tagIds: Array<string>) => {
		if (next.type === 'live_chat') {

			const { flows } = STORE.getState();
			const questions = flows[0]?.questions;
			const question = questions.find((que: IQuestion) => que.id === next.target);
		
			dispatch(updateEnvironment({
					liveChat: true,
					activeQuestion: question,
					activeQuestionType: question?.type,
				}
			));

			requestLivechat();
		}

		if (tagIds?.length) {
			dispatch(updateEnvironment({
				selectedTags: [...(environment?.selectedTags || []), ...tagIds],
			}
			));
		}

		submitAnswer(value, value, next.target);
	}, [dispatch, environment?.selectedTags]);

	return <>
		<div className="ele-single-select max-w-80 w-fit relative">
			<div className={`ele-single-select-message-label rounded-tl-xl rounded-tr-xl py-2 px-4 bg-primaryBgColor ${topMargin} ${design.singleSelectViewType === 'bubble' ? 'w-fit rounded-br-xl' : ''}`}>
				<p className="prose" dangerouslySetInnerHTML={{ __html: md.render(message.label) }} />
			</div>

			{(!design.singleSelectViewType || design.singleSelectViewType === 'list') &&
				(currentIndex === (count - 1) && (
					<div className="options-container  border-solid border-2 border-t-0 border-primaryBgColor rounded-bl-xl rounded-br-xl">
						{
							options.map((option: any, index: number) => {
								return <div
									key={option._id + option.id}
									onClick={() => selectOption(option.value, option.next || null, option?.actionBasedChatResponse?.tagIds)}
									className={`ele-list-single-select bg-white option flex cursor-pointer justify-center p-2 items-center border-solid border-t-2 border-primaryBgColor hover:bg-primaryBgColor ${index === options.length - 1 ? 'hover:rounded-b-lg' : ''} last:rounded-b-lg`}>
									<p className="text-primaryColor text-center" style={{ color: design?.themeColor }}>{option.value}</p>
								</div>
							})
						}
					</div>
				))
			}

			{design.singleSelectViewType === 'bubble' &&
				(currentIndex === (count - 1) && (
					<div className="flex flex-wrap ele-single-select-bubble-container">
						{
							options.map((option: any, index: number) => {
								return <div
									key={'bubble ' + option._id + option.id}
									onClick={() => selectOption(option.value, option.next || null, option?.actionBasedChatResponse?.tagIds)}
									className={`ele-bubble-single-select bg-white mt-2 mr-2 text-center border border-${design?.themeColor ? '[' + design?.themeColor + ']' : 'primaryColor'} px-3 py-2 rounded-full cursor-pointer w-fit hover:bg-primaryBgColor hover:border-primaryBgColor`}>
									<p className="text-primaryColor text-center" style={{ color: design?.themeColor }}>{option.value}</p>
								</div>
							})
						}
					</div>
				))
			}
		</div>
	</>
}